// CSRF token utilities for Rails
// Reads token from meta tags rendered by <%= csrf_meta_tags %>

// Returns the CSRF token from the Rails meta tag, or null if not found
export function getCsrfToken(): string | null {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta?.getAttribute('content') ?? null;
}

// Returns headers object with CSRF token and JSON content type.
// Suitable for spreading into fetch options.
export function csrfHeaders(): Record<string, string> {
  const token = getCsrfToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };
  if (token) headers['X-CSRF-Token'] = token;
  return headers;
}

// fetch rejects with a TypeError on connectivity failures. The message is
// browser-specific: "Load failed" (WebKit), "Failed to fetch" (Chromium),
// "NetworkError when attempting to fetch resource." (Firefox).
const NETWORK_ERROR_MESSAGES = [
  'Load failed',
  'Failed to fetch',
  'NetworkError when attempting to fetch resource.',
];

// True if the error is a dropped/blocked request rather than an app failure
export function isNetworkError(e: unknown): boolean {
  return e instanceof TypeError && NETWORK_ERROR_MESSAGES.includes(e.message);
}

// Fetch wrapper that automatically includes CSRF headers
export function fetchWithCsrf(url: string, options: RequestInit = {}): Promise<Response> {
  return fetch(url, {
    ...options,
    headers: { ...csrfHeaders(), ...options.headers as Record<string, string> },
  });
}

